'use client';

import { useRecoilValue } from 'recoil';
import { selectedProjectPhasesState } from '@/lib/state';
import PhaseCountdown from '@/components/PhaseCountdown';

export default function ProjectPhases() {
  const phases = useRecoilValue(selectedProjectPhasesState);
  if (!phases) {
    return null;
  }
  return (
    <div className="flex flex-col w-full space-y-2">
      {phases?.map((p) => (
        <PhaseCountdown key={p.id} phase={p} />
      ))}
    </div>
  );
}
